/**
 * @author maydays
 * @description tagsBar多标签页逻辑，前期借鉴了很多开源项目发现都有个共同的特点很繁琐并不符合框架设计的初衷
 */

import { getVisitedRoutes, setVisitedRoutes } from '@/utils/auth'
import { setLocal } from '@/utils/index'

const state = () => ({
  routes: [],
  visitedRoutes: getVisitedRoutes() || [],
})
const getters = {
  visitedRoutes: (state) => state.visitedRoutes,
  routes: (state) => state.routes,
}
const mutations = {
  setRoutes(state, routes) {
    state.routes = routes
  },
  /* 
    清空标签页
  */

  clearVisitedRoutes(state) {
    state.visitedRoutes = []
  },

  /**
   * @author maydays
   * @description 添加标签页
   * @param {*} state
   * @param {*} route
   * @returns
   */
  addVisitedRoute(state, route) {
    if (route.path === '/login' || route.path === '/403' || route.path === '/404') return
    let target = state.visitedRoutes.find((item) => item?.path === route?.path)
    if (target) {
      if (route.fullPath !== target.fullPath) Object.assign(target, route)
      return
    }
    state.visitedRoutes.push(Object.assign({}, route))
    setVisitedRoutes(state.visitedRoutes)
  },
  /**
   * @author maydays
   * @description 删除当前标签页
   * @param {*} state
   * @param {*} route
   * @returns
   */
  delVisitedRoute(state, route) {
    state.visitedRoutes.forEach((item, index) => {
      if (item.path === route.path) state.visitedRoutes.splice(index, 1)
    })
  },
  /**
   * @author maydays
   * @description 删除当前标签页以外其它全部多标签页
   * @param {*} state
   * @param {*} route
   * @returns
   */
  delOthersVisitedRoutes(state, route) {
    state.visitedRoutes = state.visitedRoutes.filter((item) => item.path === route || item.path == '/index')
    setLocal('hhxcNav-list', JSON.stringify(state.visitedRoutes))
  },
  /**
   * @author maydays
   * @description 删除当前标签页左边全部多标签页
   * @param {*} state
   * @param {*} route
   * @returns
   */
  delLeftVisitedRoutes(state, route) {
    console.log(state, route)
    let index = state.visitedRoutes.length
    state.visitedRoutes = state.visitedRoutes.filter((item) => {
      if (item.name == route.name) index = state.visitedRoutes.indexOf(item)
      return state.visitedRoutes.indexOf(item) == 0 || index <= state.visitedRoutes.indexOf(item)
    })
    setLocal('hhxcNav-list', JSON.stringify(state.visitedRoutes))
  },
  /**
   * @author maydays
   * @description 删除当前标签页右边全部多标签页
   * @param {*} state
   * @param {*} route
   * @returns
   */
  delRightVisitedRoutes(state, route) {
    let index = state.visitedRoutes.length
    state.visitedRoutes = state.visitedRoutes.filter((item) => {
      if (item.name === route.name) index = state.visitedRoutes.indexOf(item)
      return index >= state.visitedRoutes.indexOf(item)
    })
    setLocal('hhxcNav-list', JSON.stringify(state.visitedRoutes))
  },
  /**
   * @author maydays
   * @description 删除全部多标签页
   * @param {*} state
   * @param {*} route
   * @returns
   */
  delAllVisitedRoutes(state) {
    state.visitedRoutes = state.visitedRoutes.filter((item) => item.meta.title == '首页')
    setLocal('hhxcNav-list', JSON.stringify(state.visitedRoutes))
  },
}
const actions = {
  async setRoutes({ commit }, routes) {
    commit('setRoutes', routes)
  },
  /**
   * @author maydays
   * @description 添加标签页
   * @param {*} { commit }
   * @param {*} route
   */
  addVisitedRoute({ commit }, route) {
    commit('addVisitedRoute', route)
  },
  /**
   * @author maydays
   * @description 删除当前标签页
   * @param {*} { commit }
   * @param {*} route
   */
  delVisitedRoute({ commit }, route) {
    commit('delVisitedRoute', route)
  },
  /**
   * @author maydays
   * @description 删除当前标签页以外其它全部多标签页
   * @param {*} { commit }
   * @param {*} route
   */
  delOthersVisitedRoutes({ commit }, route) {
    commit('delOthersVisitedRoutes', route)
  },
  /**
   * @author maydays
   * @description 删除当前标签页左边全部多标签页
   * @param {*} { commit }
   * @param {*} route
   */
  delLeftVisitedRoutes({ commit }, route) {
    commit('delLeftVisitedRoutes', route)
  },
  /**
   * @author maydays
   * @description 删除当前标签页右边全部多标签页
   * @param {*} { commit }
   * @param {*} route
   */
  delRightVisitedRoutes({ commit }, route) {
    commit('delRightVisitedRoutes', route)
  },
  /**
   * @author maydays
   * @description 删除全部多标签页
   * @param {*} { commit }
   */
  delAllVisitedRoutes({ commit }) {
    commit('delAllVisitedRoutes')
  },
}
export default { state, getters, mutations, actions }
